export default {
    login: 'تسجيل الدخول',
    registration: 'تسجيل',
    order: 'طلبي',
    language: 'العرب',
    home: 'الصفحة الأولى',
    babyToys: 'الكلمات الرئيسية',
    aboutus: 'بشأننا',
    product: 'المنتجات',
    cart: 'عربة التسوق',
    contactus: 'اتصل بنا',
    comprehensiveInquiry: 'استفسارات شاملة',
    advancedSearch: 'بحث متقدم',
    productName: 'اسم المنتج',
    priceRange: 'نطاق السعر',
    reset: 'الاستبدال',
    search: 'البحث',
    classify: 'تصنيف',
    categories: 'تصنيف المنتجات',
    close: 'أبعد',
    open: 'إجراء',
    updateTime: 'تحديث الوقت',
    startTime: 'وقت البدء',
    endTime: 'نهاية الوقت',
    confirm: 'تأكيد',
    minimumPrice: 'أدنى سعر',
    highestPrice: 'أعلى سعر',
    L: 'طويلة',
    W: 'عرضها',
    H: 'عالية',
    inputPlaceholder: 'يرجى إدخال المحتوى',
    selectPlaceholder: 'يرجى الاختيار',
    packingCapacity: 'الحاويات',
    price: 'أسعار',
    itemNo: 'رقم المصنع',
    packing: 'مواصفات المنتج',
    productSize: 'مواصفات المنتج',
    packageSize: 'مواصفات التعبئة',
    cartonSize: 'الصندوق الخارجي',
    innerBoxAndOuterPacking: 'حالداخلية/الخارجية',
    OuterPacking: "لصناديق الخارجية",
    CBMAndCUFT: 'الحجم/الحجم',
    CUFT: 'الحجم',
    CBM: 'لحجم',
    GWAndNW: ' الإجمالي/الصافي',
    mOQ: 'قم بالحجز',
    productInformation: 'معلومات المنتج',
    relatedProducts: 'المنتجات ذات الصلة',
    more: 'المزيد',
    clear: 'إفراغ',
    inputPassword: 'يرجى إدخال كلمة المرور',
    passwordLength: '6 أن يكون طول كلمة المرور أقل من ',
    inputUserName: 'يرجى إدخال الاسم',
    inputUserAccount: 'يرجى إدخال اسم المستخدم',
    inputVaildeCode: 'يرجى إدخال رمز التحقق',
    inputMobile: 'يرجى إدخال رقم الهاتف المحمول',
    inputEmail: 'يرجى إدخال صندوق البريد',
    inputEmailRules: 'شكل صندوق البريد غير صحيح',
    password: 'كلمة المرور',
    username: 'أسماء',
    vaildecode: 'رمز التحقق',
    gender: 'نوع الجنس',
    useraccount: 'اسم المستخدم',
    man: 'الرجال',
    woman: 'النساء',
    mobile: 'رقم الهاتف',
    email: 'صندوق البريد',
    address: 'عنوان الاتصال',
    CodeError: 'خطأ تشفير التحقق',
    resUserError: 'م موجود بالفعل',
    notreviewed: 'مراجعة الحسابات',
    loginError: 'رقم الحساب أو إدخال كلمة المرور',
    loginSuccess: 'الهبوط',
    regSuccess: 'التسجيل ناجح',
    deleteSuccess: 'حذف بنجاح',
    toregister: 'لا يوجد حساب؟ التسجيل',
    toLogin: 'هل لديك حساب؟ الهبوط',
    logout: 'الانسحاب',
    myShoppingCart: 'عربة التسوق الخاصة بي',
    ID: 'رقم تسلسلي',
    picture: 'الصورة',
    ItemNO: 'رقم',
    name: 'اسم',
    total: 'مجموع',
    delete: 'حذف',
    CTNS: 'صندوق عدة',
    checkAll: 'QuanXuan',
    checkSelect: 'اختر مفتاحا إضافيا في هذه الصفحة',
    page: 'صفحة',
    goTO: 'إلى',
    totalRecords: 'المبلغ الإجمالي',
    totalCTNS: 'حجم الصندوق',
    totalQuantity: 'المجموع',
    totalPrice: 'إجمالي',
    submit: 'تقديم',
    orderDetails: 'تفاصيل الطلب',
    OrderInformation: 'معلومات الطلب',
    number: 'رقم لوحده',
    orderTime: 'وقت الطلب',
    linkman: 'الاتصال',
    remark: 'ملحوظة رقم',
    viewDetails: 'أنظر إلى التفاصيل',
    companyContact: 'الاتصال',
    companyTel: 'الهاتف',
    companyFax: 'الفاكس',
    companyMail: 'صندوق البريد',
    companyAddress: 'العنوان',
    productCenter: 'مركز المنتجات',
    helpCenter: 'مركز المساعدة',
    member: 'مركز الأعضاء',
    productdemand: 'الطلب على المنتج',
    newproduct: 'أحدث منتج',
    registerhelp: 'تسجيل المساعدة',
    orderhelp: 'طلب المساعدة',
    newproducts: 'عرض جديد',
    highRec: 'المنتجات الموصى بها',
    slogan: 'والأسرع والأفضل في التغذية المرتدة في عام 2023.',
    viewmore: 'انظر المزيد',
    videocenter: 'مركز الفيديو',
    videoSlogan: 'لنعرف المزيد عن صناعة الألعاب',
    searchPicture: 'الشكل فتش',
    choosePicture: 'اختر الصورة',
    clickOrDrag: 'انقر/اسحب الملف إلى هنا',
    copyPicture: 'انسخ الصورة: انقر هنا لللصق/CTRL + V.',
    pictureCrop: 'قطع الصورة المنطقة',
    cancel: 'إلغاء',
    confirm: 'تحديد',
    pleaseLogin: 'يرجى تسجيل الدخول',
    addCart: "أضف عربة التسوق",
    delCart: "إلغاء الطلب الإضافي",
    viewPrice: 'تحقق من السعر',
    noData: 'عدد لا يحصى من الوثائق',
    systemTip: 'نصائح النظام',
    deleteData: 'هل تُحذف هذه المادة؟',
    clearCartData: 'هل تفرغ كل عربة التسوق؟',
    orderSuccess: 'تم إنشاء النظام!',
    submitTip: 'تأكيد تقديم الطلبات؟',
    noLogin: 'إضافة عربة التسوق، يرجى الهبوط',
    notImage: 'اللصق ليس صورة',
    noSelect: 'يرجى اختيار البيانات',
    hotSaleProduct: 'مبيعات ساخنة',
    popularRecommendation: 'توصية ساخنة',
    please_contact_us: 'إأسئلة، يرجى الفاكس أو الاتصال في أي وقت',
    ock_email: 'صندوق البريد',
    contactUs: 'اتصل بنا',
    hotLine: 'الخط الساخن',
    companyAddres: 'عنوان الشركة',
    workingHours: 'ساعات العمل',
    week: 'الاثنين إلى الجمعة',
    companyInfo: 'وصف الشركة',
    noName: 'لا يوجد مترجم',
    serviceHotine: "24/7 الخط الساخن",
    success: "أضف النجاح",
    del: "حذف بنجاح",
    orderStatus: 'حالة الطلب',
    sendDate: 'تاريخ الشحن',
    expressNumber: 'رقم البريد السريع',
    unshipped: 'غير مرسل',
    shipped: 'تم شحنها',

    Disclaimer: "إبراء الذمة: جميع الموقع تأتي من جهات التصنيع، وتملك حقوق التأليف والنشر.",
    Technic: 'الدعم التقني',
    Software: 'شركة هونسو اجيا البرامجيات في شينتشن',
    coNuNum: "رقم الشركة",
    all: 'كل تصنيف',
    userAddress: 'عنوان التسليم',
    consignee: 'المرسل إليه',
    addressDetail: 'عنوان مفصل',
    addressinformation: 'معلومات عنوان الاستلام',
    defaultAddress: 'افتراضي',
    defaultSettings: 'افتراضي',
    edit: 'تحرير العنوان',
    add: 'عنوان جديد',
    AddinganAddress: 'عنوان جديد',
    Edittheaddress: 'تحرير العنوان',
    Ok: 'حفظ',
    Address_Consignee: 'يرجى إدخال المرسل إليه',
    Address_Mobile: 'يرجى إدخال رقم الهاتف المحمول',
    Address_Address: 'يرجى إدخال العنوان',
    PleaseContact: 'يرجى إدخال الاتصال',
    Video_playback: 'تشغيل الفيديو',
    "DK.navTitle.Home": "الصفحة الأولى",
    "DK.navTitle.Produch": "عرض المنتجات",
    "DK.navTitle.Cart": "عربة التسوق",
    "DK.navTitle.Exhibition": "برنامج المعرض",
    "DK.navTitle.Message": "الاتصال/عنا",
    "DK.logoBox.placeholder": "الرجاء إدخال كلمة مفتاح المنتج",
    "DK.ProductNumber": "رقم المنتج",
    "DK.amount": "عدد",
    "DK.contactUs": "اتصل بنا",
    "DK.understandDeke": "نعم ديكو",
    "DK.aboutUs": "بشأننا",
    "DK.telephone": "هاتف أرضي",
    "DK.phoneAndWeixin": "هاتف محمول،",
    "DK.PleaseOrderNum": "يرجى إدخال رقم الطلب",
    "DK.ArticleNo": "HuoHao",
    "DK.TotalVolume": "المجموع",
    "DK.totalQTY": "المجموع",
    "DK.totalItems": "المبلغ الإجمالي",
    "DK.ExhibitionRelatedProducts": "المعارض المنتجات المرتبطة",
    "DK.ProductsVideo": "فيديو المنتج",
    "DK.ReleaseDate": "تاريخ الإصدار",
    "DK.inquirySheet": "طلب طلب",
    "DK.SendInquiry": "طلب طلب",
    "DK.productPrice": "سعر المنتج",
    "DK.OuterBoxCBM": "حجم الصناديق الخارجية",
    "DK.OuterBoxCUFT": "صندوق السيارة",
    "DK.Innerboxes": "الصندوق الداخلي",
    "DK.OuterCapacity": "حجيق الخارجية",
    "DK.productDetails": "تفاصيل المنتج",
    "DK.similarProduct": "منتجات متشابهة",
    "DK.MyRFQ": "طلبعلام الخاص بي",
    "DK.enquiry": "عروض الأسعار",
    "DK.enquirys": "يرجى ترك بريدك الإلكتروني وسوف نتصل بك",
    "DK.contact": "معلومات الاتصال",
    "DK.Description": "اسم",
    "DK.OuterQTY": "حجم الصناديق الخارجية",
    "DK.LastSevenDays": "البعة الأخيرة",
    "DK.All": "كل",
    "DK.PleaseEmial": "يرجى إدخال صندوق البريد",
    "DK.PleaseCode": "يرجى إدخال رمز التحقق",
    "DK.PleasePhone": "يرجى الهاتف المحمول",
    "DK.PleaseName": "يرجى إدخال اسم المستخدم",
    "DK.userName": "اسم المستخدم",
    "DK.PleaseAddress": "يرجى إدخال عنوان الاتصال",
    "DK.HighRec": 'مبيعات ساخنة',
}
